import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { getTotalDeposits } from '../core/utils'
import { useHistory } from 'react-router-dom'
import Input from 'components/inputs/Input'
import React from 'react'

interface SummaryProps {
  selectedData: payments.SelectedData
  response?: payments.CancelRentalResponse
  selectData: React.Dispatch<React.SetStateAction<payments.SelectedData>>
}

const Summary: React.FC<SummaryProps> = ({ response, selectedData, selectData }) => {
  const deposit = getTotalDeposits(selectedData, response?.warehouses?.[0])

  const { goBack } = useHistory()
  const { t } = useTranslation('warehouse')

  return <>
    <div className='title'>
      <div>{t('payments')}</div>
      <div>{t('completeTheFormalities')}</div>
    </div>

    <div className='resignation__main'>
      <div className='resignation__list'>
        <Input
          name='refundName'
          label={t('recipientName')}
          placeholder={t('enterTheRecipientName')}
          value={selectedData.refundName || ''}
          changeHandler={e => {
            selectData(prev => ({ ...prev, refundName: e.target.value }))
          }}
        />
        <Input
          name='refundAccountNumber'
          label={t('bankAccountNumber')}
          placeholder={t('enterYourBankAccountNumber')}
          value={selectedData.refundAccountNumber || ''}
          changeHandler={e => {
            selectData(prev => ({ ...prev, refundAccountNumber: e.target.value }))
          }}
        />
      </div>

      <div className='resignation__buttons'>
        <ArrowBtn
          enlarged
          disabled={deposit > 0 && (!selectedData.refundName || !selectedData.refundAccountNumber)}
          text={t((deposit > 0 && selectedData.refundName && selectedData.refundAccountNumber)
            ? 'save'
            : 'next')}
          action={() => {
            goBack()
          }}
        />

        <BackBtn />
      </div>
    </div>
  </>
}

export default Summary